import {
  PPTbuildBarChartData,
  PPTbuildDoughnutChartData,
  PPTbuildGeographyChartData,
  PPTbuildLineChartData,
  PPTbuildSankeyChartData,
  PPTbuildWordcloudData,
} from './pptDataBuilder';
import { PPTDataProcessor, PPTWidgetRenderer } from '../../../../models/pptx.model';
import {
  PPTbarChartRenderer,
  PPTdoughnutChartRenderer,
  PPTelsieSummaryRenderer,
  PPTgeographyChartRenderer,
  PPTlineChartRenderer,
  PPTsankeyChartRenderer,
  PPTwordcloudRenderer,
} from './pptWidgetRenderer';
import { SupportedWidgetRenderType } from './pptWidgetConfig';

export const PPT_DATA_PROCESSOR_MAP: PPTDataProcessor = {
  [SupportedWidgetRenderType.Bar]: PPTbuildBarChartData,
  [SupportedWidgetRenderType.Sankey]: PPTbuildSankeyChartData,
  [SupportedWidgetRenderType.Wordcloud]: PPTbuildWordcloudData,
  [SupportedWidgetRenderType.Doughnut]: PPTbuildDoughnutChartData,
  [SupportedWidgetRenderType.Line]: PPTbuildLineChartData,
  [SupportedWidgetRenderType.Geography]: PPTbuildGeographyChartData,
};

export const PPT_RENDER_MAP: PPTWidgetRenderer = {
  [SupportedWidgetRenderType.Bar]: PPTbarChartRenderer,
  [SupportedWidgetRenderType.Sankey]: PPTsankeyChartRenderer,
  [SupportedWidgetRenderType.Wordcloud]: PPTwordcloudRenderer,
  [SupportedWidgetRenderType.Doughnut]: PPTdoughnutChartRenderer,
  [SupportedWidgetRenderType.Pie]: PPTdoughnutChartRenderer,
  [SupportedWidgetRenderType.Line]: PPTlineChartRenderer,
  [SupportedWidgetRenderType.Geography]: PPTgeographyChartRenderer,
  [SupportedWidgetRenderType.Elsie]: PPTelsieSummaryRenderer,
};
